import { cookie, post } from "./base";

const imageEndpoint = "userimages/";
const audioEndpoint = "userbgaudio/";
const videoEndpoint = "userbgvideo/";
const documentEndpoint = "upload_file/";

export const uploadHandler = async (
  userId,
  fileHandle,
  type = "image",
  payload
) => {
  const getUploadDetails = () => {
    switch (type) {
      case "audio":
        return { endpoint: audioEndpoint, name: "audio" };
      case "video":
        return { endpoint: videoEndpoint, name: "video" };
      case "document":
        return { endpoint: documentEndpoint, name: "file" };

      default:
        return { endpoint: imageEndpoint, name: "image" };
    }
  };
  const { endpoint, name } = getUploadDetails();
  try {
    const formData = new FormData();

    if (fileHandle instanceof File) {
      formData.append("name", fileHandle.name.split(".").slice(0, -1));
      formData.append("userId", userId);
      formData.append(name, fileHandle); // Append the file handle with its original name
      if (payload && typeof payload === "object") {
        Object.keys(payload).forEach((key) => {
          formData.append(key, payload[key]);
        });
      }
    } else {
      throw new Error("Invalid file handle provided.");
    }

    const response = await post(
      process.env.REACT_APP_SERVER_API_URL + endpoint,
      formData,
      {
        thirdParty: true,
        headers: {
          "Content-Type": "multipart/form-data",
          "X-CSRFToken": cookie("csrftoken"),
        },
      }
    );

    if (response) {
      // Successfully uploaded the image,audio
      return response;
    } else {
      // Handle any error responses here
      throw new Error("Failed to upload");
    }
  } catch (error) {
    // Handle network or other errors here
    throw new Error("Network error: " + error.message);
  }
};

export const audioUploadHandler = async (userId, fileHandle) => {
  const endpoint = "/useraudio/";

  try {
    const formData = new FormData();

    if (fileHandle instanceof File) {
      formData.append("name", fileHandle.name.split(".").slice(0, -1));
      formData.append("userId", userId);
      formData.append("audio", fileHandle); // Append the file handle with its original name
    } else {
      throw new Error("Invalid file handle provided.");
    }

    const response = await post(
      process.env.REACT_APP_SERVER_API_URL + endpoint,
      formData,
      {
        thirdParty: true,
        headers: {
          "Content-Type": "multipart/form-data",
          "X-CSRFToken": cookie("csrftoken"),
        },
      }
    );
    if (response.audio) {
      // Successfully uploaded the image
      return response;
    } else {
      // Handle any error responses here
      throw new Error("Failed to upload image");
    }
  } catch (error) {
    // Handle network or other errors here
    throw new Error("Network error: " + error.message);
  }
};
